import { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Button } from "../ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "../ui/dialog";

/**
 * Cancellare uno sport personale mai usato (D5 di docs/sport-config).
 *
 * Si offre solo quando il server dichiara lo sport `deletable`: nessuno lo
 * usa, a parte il coach che l'ha creato. Chi lo usa già lo disattiva. Il
 * server ricontrolla comunque, e risponde 409 se nel frattempo qualcuno l'ha
 * agganciato.
 *
 * Props: sport, open, onOpenChange, onConfirm (async).
 */
export function DeleteSportDialog({ sport, open, onOpenChange, onConfirm }) {
	const { t } = useLanguage();
	const [saving, setSaving] = useState(false);

	const confirm = async () => {
		setSaving(true);
		try {
			await onConfirm?.();
			onOpenChange(false);
		} finally {
			setSaving(false);
		}
	};

	return (
		<Dialog open={open} onOpenChange={(next) => !saving && onOpenChange(next)}>
			<DialogContent className="bg-card border-border max-w-md">
				<DialogDescription className="hidden" />
				<DialogHeader>
					<DialogTitle>
						{t("scDeleteTitle").replace("{label}", sport?.label || sport?.value || "")}
					</DialogTitle>
				</DialogHeader>
				<p className="text-sm text-muted-foreground">{t("scDeleteBody")}</p>
				<div className="flex justify-end gap-2 pt-2">
					<Button
						variant="ghost"
						className="rounded-sm"
						disabled={saving}
						onClick={() => onOpenChange(false)}
					>
						{t("cancel")}
					</Button>
					<Button
						variant="destructive"
						className="rounded-sm"
						disabled={saving}
						onClick={confirm}
					>
						{t("scDelete")}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
